import React from 'react';

import FlexCentered from 'components/Common/FlexCentered';
import List from 'components/List';
import Typography from 'kingpin/atoms/Typography';
import UserListItem from './UserListItem';

const UserListInner = ({
  users,
  isLoading,
  onUserRemoved,
  emptyMessage,
}: {
  users: (UserManagement.PendingUser | UserManagement.SignedUpUser)[];
  isLoading: boolean;
  onUserRemoved: (
    user: UserManagement.PendingUser | UserManagement.SignedUpUser,
  ) => Promise<void>;
  emptyMessage?: string;
}) => {
  const isNoUsers = users.length === 0;
  if (isNoUsers) {
    return (
      <FlexCentered style={{ height: 100 }}>
        <Typography.Body type="Body 12">
          {emptyMessage ? emptyMessage : 'No Users'}
        </Typography.Body>
      </FlexCentered>
    );
  }
  return (
    <div style={{ border: '1px solid var(--color-grey-8)' }}>
      {users.map((u, index) => (
        <UserListItem
          user={u}
          isLoading={isLoading}
          onUserRemoved={onUserRemoved}
          key={u.id}
          isLast={index === users.length - 1}
        />
      ))}
    </div>
  );
};

const UsersList = ({
  users,
  onUserRemoved,
  emptyMessage,
  isLoading,
}: {
  users: (UserManagement.PendingUser | UserManagement.SignedUpUser)[];
  onUserRemoved: (
    user: UserManagement.PendingUser | UserManagement.SignedUpUser,
  ) => Promise<void>;
  emptyMessage?: string;
  isLoading: boolean;
}) => {
  return (
    <List
      noBorder
      noMargin
      Headers={null}
      Body={
        <UserListInner
          users={users}
          isLoading={isLoading}
          onUserRemoved={onUserRemoved}
          emptyMessage={emptyMessage}
        />
      }
    />
  );
};

export default UsersList;
